module.exports = __webpack_public_path__ + "img/product_2.0687da09.jpg";